module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/time-roll-approval/time-roll-apprve-form/time-roll-apprve-form.component.css
// module id = ./src/app/hrms/Attendance-Leaves/time-roll-approval/time-roll-apprve-form/time-roll-apprve-form.component.css
// module chunks = main